import { signal } from "@angular/core";

export const alarmasPermitidasSignal = signal<Set<number> | null>(null);
